import { Link } from "react-router-dom";
import styles from '../../../pages/LeadCapture/LeadCaptureList/LeadCaptureList.module.css'
// image elements
const LCEvent = ({ index, eventItem }) => {
    const changeDateFormat = dateStr => {
        const parsedDate = Date.parse(dateStr)
        const date = new Date(parsedDate)
        const options = { weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric' };
        const dateFormatted = date.toLocaleDateString('en-us', options);
        const returnDate = dateFormatted.split(' ').slice(1).join('/')
        return returnDate
    }
    return (
        <>
            <Link to={`/LeadCaptureOrder/${eventItem.refNumber}`} state={eventItem}>{eventItem.overwriteName} - {changeDateFormat(eventItem.eventStartDate)} ({eventItem.client.clientName})</Link>             
        </>
    );
}

export default LCEvent;